import Color from "color";
import { PlayerLayout } from "../layouts/PlayerLayout";

import logoJustDice from "../../assets/logo_dice.svg";
import logoJustDiceBlack from "../../assets/logo_dice_black.svg";
import logoNoDice from "../../assets/logo_no_dice.svg";

type LoadingScreenProps = {
  backgroundColor?: string;
  foregroundColor?: string;
};

export function LoadingScreen({
  backgroundColor,
  foregroundColor,
}: LoadingScreenProps) {
  const SIZE = 150;
  const DICE_SIZE = (162.97 / 422.0) * SIZE;
  const bgColor = backgroundColor ?? "#000000";
  const fgColor = foregroundColor ?? "#ffffff";
  const overWhite = Color(bgColor).luminosity() > 0.8;

  return (
    <PlayerLayout backgroundColor={bgColor} foregroundColor={fgColor}>
      <img
        style={{
          position: "absolute",
          left: `calc(50% - ${SIZE / 2}px)`,
          top: `calc(45% - ${SIZE / 2}px)`,
          width: SIZE,
          height: SIZE,
          animation: "spinReverse 60s linear infinite",
        }}
        src={logoNoDice}
      />

      <div
        style={{
          position: "absolute",
          left: `calc(50% - ${DICE_SIZE / 2}px)`,
          top: `calc(45% - ${DICE_SIZE / 2}px)`,
          width: DICE_SIZE,
          height: DICE_SIZE,
          animation: "spinAccelDecel 5s ease-in-out infinite",
        }}
      >
        <img
          style={{
            width: DICE_SIZE,
            height: DICE_SIZE,
            position: "absolute",
          }}
          src={logoJustDice}
        />
        <img
          style={{
            width: DICE_SIZE,
            height: DICE_SIZE,
            position: "absolute",
            opacity: overWhite ? 1 : 0,
            transition: "opacity 0.5s linear",
          }}
          src={logoJustDiceBlack}
        />
      </div>

      <style>{`
        @keyframes spinAccelDecel {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(2160deg);
          }
        }
        @keyframes spinReverse {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(-360deg);
          }
        }
      `}</style>
    </PlayerLayout>
  );
}
